define(['edge/platform/widgets/wizard/NavBarWizardBaseCtrl'], NavBarWizardBaseCtrl => {
    return ['$scope', '$element', 'StateUtils', '$rootScope', '$state', 'LoginLinkDev','LoginLinkTest','AAADEV','AAATEST','GWDEV','GWTEST',
        function ($scope, $element, StateUtils, $rootScope, $state, LoginLinkDev, LoginLinkTest, AAADEV, AAATEST, GWDEV, GWTEST) {

            const baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
            const ctrl = Object.create(baseNavbarCtrl);

            function addPageInfoToAnalytics () {
                if($scope.submission && $scope.submission.draftData.productCode){
                    var insuranceType = $scope.submission.draftData.productCode;
                }else{
                    var insuranceType = "Product NA";
                }

                if($state.current && $state.current.name){
                    var stateName = $state.current.name;
                }else{
                    var stateName = "State NA";
                }

        // CHG0031104 - Set QnB Source for Google Analytics
        // AB - 05/12/2018

        // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
        // AB - 11/23/2020

                switch($rootScope.Arg1){
//                switch($rootScope.Arg1.toUpperCase()){
                    case "SECU":
                        var source = "SECU"
                      break
                    case "GORMISH":
                        var source = "GORMISH"
                      break
                    case "SEA":
                        var source = "SEA"
                      break
                    case "YOMTOB":
                        var source = "YOMTOB"
                      break
                    case "BWE":
                        var source = "BWE"
                      break
                    case "SCOTT":
                        var source = "SCOTT"
                      break
                    case "CROWFIELD":
                        var source = "CROWFIELD"
                      break
                    case "RICKARD":
                        var source = "RICKARD"
                      break
                    case "NIXON":
                        var source = "NIXON"
                      break
                    case "BLUE":
                        var source = "BLUE"
                      break
                    case "GRAY":
                        var source = "GRAY"
                      break
                    case "JONES":
                        var source = "JONES"
                      break
                    case "MCCARTHY":
                        var source = "MCCARTHY"
                      break
                    case "ASSOCIATES":
                        var source = "ASSOCIATES"
                      break
                    case "ANTHONY":
                        var source = "ANTHONY"
                      break

                    case "SIMMONS":
                        var source = "SIMMONS"
                      break
                    case "WILLIAMS":
                        var source = "WILLIAMS"
                      break
                    case "MORRISON":
                        var source = "MORRISON"
                      break
                    case "CRUMEL":
                        var source = "CRUMEL"
                      break
                    case "YOU":
                        var source = "YOU"
                      break
                    case "MILLER":
                        var source = "MILLER"
                      break
                    case "PERSINSKI":
                        var source = "PERSINSKI"
                      break
                    case "FLOURNOY":
                        var source = "FLOURNOY"
                      break
                    default:
                        var source = "AAA"
                }

                dataLayer.push({
                    event: insuranceType + ' : State Change',
                    virtualPageURL: '/qnb-flow/'+stateName,
                    virtualPageTitle: insuranceType+':'+stateName,
                    quoteSource: source

                });

//                console.log("Data Layer", dataLayer);
            }


            ctrl.init = ()=> {
                $scope.headerMessageKey = '';
                $scope.isContextPageMenuOpen = false;

                //Added to display the year dynamically in footer
                $scope.CurrentYear = new Date();

                $rootScope.$on('stickyHeaderExitViewport', ctrl.closeContextPageMenu);
                $scope.$on('updateHeaderMessageKey', (event, messageKey) => {
                    $scope.updateHeaderMessageKey(messageKey);
                });

                StateUtils.beforeStateInit(ctrl._setQuoteSummaryData);
                StateUtils.afterStateInit(ctrl._checkIfSideMenuShouldBeClosed);

                $rootScope.$on('$stateChangeSuccess',addPageInfoToAnalytics);

                /*$rootScope.$on('$stateChangeStart',addPageInfoToAnalytics);*/

                // CHG0031104 - Capture QnB Source
                // AB - 05/12/2018

                var urlString = window.location.search.substring(1) // Extract argument string from url
                var argArray = urlString.split('&');                // build array of url arugemnts
                var argKeyValuePair = argArray[0].split('=');       // pick the first row from argArray (Source)
                $rootScope.Arg1 = argKeyValuePair[1]                // pick the 2nd element
            };

            //TODO:this function is used for login from dev and test environment. To be changed when moving to other environments.
            ctrl.navigateToLogin = function () {
                var link = window.location;
                if(link.host.indexOf(AAADEV) >= 0 || link.host.indexOf(GWDEV) >= 0){
                    window.location = LoginLinkDev;
                }
                else if(link.host.indexOf(AAATEST) >= 0 || link.host.indexOf(GWTEST) >= 0){
                    window.location = LoginLinkTest;
                }

            };

            ///// Context menu methods ///////////////////////////////////////////
            ctrl.toggleContextPageMenu = function () {
                $scope.isContextPageMenuOpen = !$scope.isContextPageMenuOpen;
            };

            ctrl.closeContextPageMenu = function () {
                $scope.isContextPageMenuOpen = false;
            };

            ///// Header message ///////////////////////////////////////////
            $scope.updateHeaderMessageKey = (messageKey)=> {
                $scope.headerMessageKey = messageKey;
            };

        // CHG0031104 - Capture QnB Source
        // This function is called in index.html page. The function returns the QnB Source //////////

            $scope.GetQnBSource = ()=> {
                var urlString = window.location.search.substring(1) // Extract argument string from url
                var argArray = urlString.split('&');                // build array of url arugemnts
                var argKeyValuePair = argArray[0].split('=');       // pick the first row from argArray (Source)
                var qnbSource = argKeyValuePair[1]                  // pick the 2nd element
                if (qnbSource == null){
                    return qnbSource;                                   // return qnbSource as null
                } else{

                    return qnbSource.toUpperCase();                     // return qnbSource in Upper Case

                }
            };

            $scope.shouldShowHeaderMessage = ()=> {
                return $state.$current.name === 'quickQuote' && angular.isDefined($scope.headerMessageKey);
            };

            ///////////// Quote summary dropdown methods /////////////////////////
            ctrl._setQuoteSummaryData = function () {
                if (StateUtils.hasState('baseQnbWizard')) {
                    $scope.submission = StateUtils.dataForState('baseQnbWizard').flowModel.snapshot.value;
                } else {
                    $scope.submission = null;
                }
            };

            ctrl._isQuoteWizardVisible = function () {
                return StateUtils.hasState('baseQnbWizard');
            };

            ctrl._checkIfSideMenuShouldBeClosed = function () {
                if (!ctrl._isQuoteWizardVisible() && ctrl.isSideBarMenuVisible()) {
                    ctrl.hideSideBarMenu();
                }
            };

            return ctrl.create($scope);
        }
    ];
});



/** WEBPACK FOOTER **
 ** ./app/js/portal/directives/NavBarCtrl.js
 **/